var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("g",{"key":1},React.createElement("g",{"id":"post-linkedin"},React.createElement("path",{"className":"st0","d":"M459,0H51C23,0,0,23,0,51v408c0,28,23,51,51,51h408c28,0,51-23,51-51V51C510,23,487,0,459,0z M153,433.5H76.5\n\t\t\tV204H153V433.5z M114.8,160.6c-25.5,0-45.9-20.4-45.9-45.9s20.4-45.9,45.9-45.9s45.9,20.4,45.9,45.9S140.3,160.6,114.8,160.6z\n\t\t\t M433.5,433.5H357V298.4c0-20.4-17.9-38.3-38.3-38.3s-38.3,17.9-38.3,38.3v135.1H204V204h76.5v30.6c12.8-20.4,40.8-35.7,63.8-35.7\n\t\t\tc48.5,0,89.3,40.8,89.3,89.3V433.5z"})))]);
}

Linkedin.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 510 510","style":{"enableBackground":"new 0 0 510 510"},"xmlSpace":"preserve"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
